{
  // as an example to see how to use this check out align-practice sites
  class GMap extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      if(this.loaded){
        return
      }
      this.loaded = true
          
      // user-controlled vars
      this._apiKey = this.getAttribute('api-key')
      this._centerLat = this.hasAttribute('center-lat') ? parseFloat(this.getAttribute('center-lat')) : 42.3314
      this._centerLng = this.hasAttribute('center-lng') ? parseFloat(this.getAttribute('center-lng')) : -83.0458
      this._initialZoom = this.hasAttribute('initial-zoom') ? parseInt(this.getAttribute('initial-zoom')) : 12
      this._minimumZoom = this.hasAttribute('minimum-zoom') ? parseInt(this.getAttribute('minimum-zoom')) : 9999
      this._mapStyle = this.hasAttribute('map-style') ? JSON.parse(this.getAttribute('map-style')) : {}
      this._aspectRatio = this.hasAttribute('aspect-ratio') ? this.getAttribute('aspect-ratio') : "16/9"
      this._zoomToFitMarkers = this.hasAttribute('zoom-to-fit-markers') ? this.getAttribute('zoom-to-fit-markers') == 'true' : true
      
      // private vars
      this._map = null // a gmap object
      this._markers = [] // an array of gmap marker objects
      this._openInfoWindow = null // an infowindow object
      this.querySelectorAll('[id^="map-"]').forEach(el => el.remove())
      this._mapEl = document.createElement('div')
      
      // initialize styles
      this._mapEl.id = "map-" + Math.random().toString(16).slice(2)
      this._mapEl.style.aspectRatio = this._aspectRatio
      this._mapEl.style.width = "100%"
      this._mapEl.style.backgroundColor = "#ccc"
      this.append(this._mapEl)
      this.style.display = 'flex'
      this.querySelectorAll('g-marker').forEach(gm => gm.style.display = 'none')
      
      // lazy load google script
      if(this.getAttribute('loading') == 'eager'){
        this._loadMap()
      } else {
        const observer = new IntersectionObserver(entries => {
          if(entries[0].isIntersecting && !this._map){
            this._loadMap()
          }
        });
        observer.observe(this);
      }

      // watch for marker changes
      const mutationObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if(this._map){
            this._addMarkers()
          }
        });    
      });    
      mutationObserver.observe(this, { childList: true });

    }
    
    _loadMap(callback = null){
      if(!document.querySelector('script[src*="https://maps.googleapis.com/maps/api/js"]')){
        const gmaps = document.createElement('script')
        gmaps.async = true
        gmaps.src = `https://maps.googleapis.com/maps/api/js?callback=Function.prototype&libraries=marker&key=${this._apiKey}`
        gmaps.onload = () => {
          this._map = new google.maps.Map(this._mapEl, {
            center: new google.maps.LatLng(this._centerLat, this._centerLng),
            zoom: this._initialZoom,
            styles: this._mapStyle
          })
          this._addMarkers()
          if(typeof callback == 'function'){
            callback()
          }
          google.maps.event.addListenerOnce(this._map, 'bounds_changed', () => {
            if(this._map.getZoom() > this._minimumZoom){
              this._map.setZoom(this._minimumZoom)
            }
          })
        }
        const head = document.querySelector('head')
        head.insertBefore(gmaps, head.lastChild)
      } else {
        if(!this._map){
          this._map = new google.maps.Map(this._mapEl, {
            center: new google.maps.LatLng(this._centerLat, this._centerLng),
            zoom: this._initialZoom,
            styles: this._mapStyle
          })
        }
        this._addMarkers()
        if(typeof callback == 'function'){
          callback()
        }
      }
    }
    
    _addMarkers(){
      this.querySelectorAll('g-marker').forEach(gm => gm.style.display = 'none')
      this._markers.forEach(marker => marker.setMap(null))
      this._markers = []

      this.querySelectorAll('g-marker').forEach(markerSlot => {
        const lat = markerSlot.getAttribute('lat')
        const lng = markerSlot.getAttribute('lng')

        if(!lat || !lng || isNaN(parseFloat(lat)) || isNaN(parseFloat(lng))){
          return
        }

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: this._map,
          position: { 
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          },
          icon: {
            url: markerSlot.hasAttribute('icon-url') ? markerSlot.getAttribute('icon-url') : null
          }
        })
        
        if(markerSlot.innerHTML){
          const infoWindow = new google.maps.InfoWindow({ 
            content: markerSlot.innerHTML 
          })
          marker.addListener('click', () => {
            if (this._openInfoWindow) {
              this._openInfoWindow.close()
            }
            this._openInfoWindow = infoWindow
            infoWindow.open({ anchor: marker, map: this._map })
          })
          
          if(markerSlot.getAttribute('initially-open') == 'true'){
            if (this._openInfoWindow) {
              this._openInfoWindow.close()
            }
            this._openInfoWindow = infoWindow
            infoWindow.open({ anchor: marker, map: this._map })
          }
        }

        this._markers.push(marker)    
      })
      
      
      setTimeout(() => {
        if(this._markers.length && this._zoomToFitMarkers){
          const bounds = new google.maps.LatLngBounds()
          this._markers.forEach(marker => bounds.extend(marker.getPosition()))
          this._map.fitBounds(bounds)
        }

        setTimeout(() => {
          if(this._map.getZoom() > this._minimumZoom){
            this._map.setZoom(this._minimumZoom)
          }
        }, 1000)
      })
    }
    
    popup(index){
      if(!this._map){
        this._loadMap(() => {
          const marker = this._markers[index]
          new google.maps.event.trigger( marker, 'click')
          this.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      } else {
        const marker = this._markers[index]
        new google.maps.event.trigger( marker, 'click')
        this.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }

  class GMarker extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('g-map', GMap)
  customElements.define('g-marker', GMarker)
}